import {
  GISSTANDINCONSISTENCY_FIELDS_WITHOUT_PROPERTY,
  GISSTANDINCONSISTENCY_MENU_CATEGORY,
  GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
  GISSTANDINCONSISTENCY_PERMISSION,
} from '../gis-stand-inconsistency/gis-stand-inconsistency.config';

export const GISSTANDINCONSISTENCYONLYINGIS_FIELDS = GISSTANDINCONSISTENCY_FIELDS_WITHOUT_PROPERTY;

export const GISSTANDINCONSISTENCYONLYINGIS_CONFIG = {
  entityName: 'GisStandInconsistencyOnlyInGis',
  localizationKey: 'Geographic::Entity.GisStandInconsistency.OnlyInGis',
  fields: GISSTANDINCONSISTENCYONLYINGIS_FIELDS,
  permission: GISSTANDINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: GISSTANDINCONSISTENCY_MENU_CATEGORY,
  menuSubcategory: GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
};